import IconButton from '@mui/material/IconButton';
import { styled } from '@mui/material/styles';

export const NavMobileMenuIconButton = styled(IconButton, {
    shouldForwardProp: (prop: string) => !['drawerWidth'].includes(prop),
})(({ theme }) => ({
    [theme.breakpoints.up('md')]: {
        display: 'none',
    },
    marginRight: '2rem',
    color: 'var(--element-active)',
}));
